import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { TRANSACTIONS_INITIAL_STATE } from "../constants/transactions.constants";
import { PAGE_PROPS } from "../constants/common";
import { ISearchAPIPayload } from "../types/common";

export const getSuperAgentDetailsByMobile = createAsyncThunk(
  "transaction/getSuperAgentDetails",
  async (mobile: string) => {
    const response: any = await axios.get(
      "/api/Transaction/GetSuperAgentByMobile/" + mobile
    );
    return response.data || response?.response?.data;
  }
);
export const getSubAgentDetailsByMobile = createAsyncThunk(
  "transaction/getSuperAgentByMobile",
  async (mobile: string) => {
    const response: any = await axios.get(
      "/api/Transaction/GetSubAgentByMobile/" + mobile
    );
    return response.data || response?.response?.data;
  }
);

export const saveTransaction = createAsyncThunk(
  "transaction/save",
  async (data: Record<string, any>) => {
    const response: any = await axios.post(
      "/api/Transaction/SaveTransaction",
      data
    );
    return response.data || response?.response?.data;
  }
);

export const getPagedTransactions = createAsyncThunk(
  "transaction/getPagedTransactions",
  async (data: ISearchAPIPayload) => {
    const response: any = await axios.post(
      "/api/Transaction/SearchPagedTransactions",
      data
    );
    return response.data || response?.response?.data;
  }
);

export const getTransactionByReferenceNo = createAsyncThunk(
  "transaction/getTransactionByReferenceNo",
  async (referenceNo: string) => {
    const response: any = await axios.get(
      "/api/Transaction/GetTransactionByReferenceNo/" + referenceNo
    );
    return response.data || response?.response?.data;
  }
);

export const transactionsSlice = createSlice({
  name: "transactions",
  initialState: TRANSACTIONS_INITIAL_STATE,
  reducers: {
    onChangeTransactionsList: (state, action) => {
      state.pageProps = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSuperAgentDetailsByMobile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSuperAgentDetailsByMobile.fulfilled, (state, action) => {
        state.loading = false;
        state.superAgentInfo = action.payload?.result;
      })
      .addCase(getSuperAgentDetailsByMobile.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getSubAgentDetailsByMobile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSubAgentDetailsByMobile.fulfilled, (state, action) => {
        state.loading = false;
        state.subAgentInfo = action.payload?.result;
      })
      .addCase(getSubAgentDetailsByMobile.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(saveTransaction.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveTransaction.fulfilled, (state, action) => {
        state.loading = false;
        state.superAgentInfo = action.payload?.result;
      })
      .addCase(saveTransaction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getPagedTransactions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPagedTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload?.result ?? PAGE_PROPS;
      })
      .addCase(getPagedTransactions.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getTransactionByReferenceNo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTransactionByReferenceNo.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTransaction = action.payload?.result ?? PAGE_PROPS;
      })
      .addCase(getTransactionByReferenceNo.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { onChangeTransactionsList } = transactionsSlice.actions;

export default transactionsSlice.reducer;
